document.addEventListener('DOMContentLoaded', function () {
  initWorkspaceBuilders(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initWorkspaceBuilders(event.target);
});

function initWorkspaceBuilders(scope) {
  const sections = scope.querySelectorAll('.workspace-builder');

  sections.forEach(function (section) {
    if (section.dataset.workspaceInitialized === 'true') return;
    section.dataset.workspaceInitialized = 'true';

    const sectionId = section.id.replace('workspace-builder-', '');
    const configScript = document.getElementById('workspace-builder-config-' + sectionId);

    let config = {
      discountTiers: [],
      accessoryDiscountTiers: [],
      baseSetupDiscount: {
        amount: '0',
        code: ''
      },
      currencyCode: 'USD'
    };

    if (configScript) {
      try {
        const parsed = JSON.parse(configScript.textContent);
        config = Object.assign({}, config, parsed || {});
      } catch (error) {
        console.error('[Workspace Builder] invalid config JSON', error);
      }
    }

    const state = {
      selectedItems: [],
      cartItems: [],
      isSubmitting: false,
      isRemoving: false,
      copiedCode: '',
      activeSoldOutCard: null,
      activeModalFallback: null,
      modalShakeTimer: null
    };

    const els = {
      viewport: section.querySelector('.workspace-builder__viewport'),
      canvas: section.querySelector('.workspace-builder__canvas'),
      bundleContainer: section.querySelector('#workspace-benefits-bundle'),
      coreContainer: section.querySelector('#workspace-benefits-core'),
      upgradesContainer: section.querySelector('#workspace-benefits-upgrades'),
      accessoriesContainer: section.querySelector('#workspace-benefits-accessories'),
      addonsPrice: section.querySelector('#workspace-addons-price'),
      totalPrice: section.querySelector('#workspace-total-price'),
      progressFill: section.querySelector('#workspace-progress-fill'),
      progressText: section.querySelector('#workspace-progress-text'),
      desktopCTA: section.querySelector('#workspace-add-bundle'),
      mobileCTA: section.querySelector('#workspace-mobile-cta'),
      desktopCTAText: section.querySelector('[data-workspace-cta-text]'),
      mobileCTAText: section.querySelector('[data-workspace-mobile-cta-text]'),
      mobileTotal: section.querySelector('#workspace-mobile-total'),

      bundleRow: section.querySelector('#workspace-bundle-row'),
      bundleRowLabel: section.querySelector('#workspace-bundle-row-label'),
      discountValue: section.querySelector('#workspace-discount-value'),
      discountCodeWrap: section.querySelector('#workspace-discount-code-wrap'),
      discountCodeBtn: section.querySelector('#workspace-discount-code-btn'),
      discountCodeText: section.querySelector('#workspace-discount-code-text'),
      discountNote: section.querySelector('#workspace-discount-note'),

      mobileSavings: section.querySelector('#workspace-mobile-savings'),
      mobileDiscountCodeWrap: section.querySelector('#workspace-mobile-discount-code-wrap'),
      mobileDiscountCodeBtn: section.querySelector('#workspace-mobile-discount-code-btn'),
      mobileDiscountCodeText: section.querySelector('#workspace-mobile-discount-code-text'),
      mobileDiscountNote: section.querySelector('#workspace-mobile-discount-note'),

      desktopUpsellHint: section.querySelector('#workspace-upsell-hint'),
      mobileUpsellHint: section.querySelector('#workspace-mobile-upsell-hint'),

      soldOutModal: section.querySelector('#workspace-soldout-modal-' + sectionId),
      soldOutModalDialog: section.querySelector('#workspace-soldout-modal-' + sectionId + ' .workspace-modal__dialog'),
      soldOutModalProductLine: section.querySelector('[data-soldout-product-line]'),
      soldOutModalCopy: section.querySelector('[data-soldout-modal-copy]'),
      soldOutPrimary: section.querySelector('[data-soldout-primary]'),

      upgradesSection: section.querySelector('[data-upgrades-section]'),
      bundleFallbackSection: section.querySelector('#workspace-bundle-fallback-' + sectionId),
      bundleCard: section.querySelector('[data-bundle-card]'),
      bundleTitle: section.querySelector('[data-bundle-title]'),
      bundleSubtitle: section.querySelector('[data-bundle-subtitle]'),
      bundlePriceDisplay: section.querySelector('[data-bundle-price-display]'),
      bundleSelectBtn: section.querySelector('[data-bundle-select-btn]'),
      bundleVariantSelect: section.querySelector('[data-bundle-variant-select]')
    };

    const cards = Array.from(
      section.querySelectorAll('.workspace-card--core, .workspace-card--upgrade, .workspace-accessory')
    );

    const allSelectableCards = cards.concat(els.bundleCard ? [els.bundleCard] : []);

    function isSoldOutModalOpen() {
      return !!(els.soldOutModal && !els.soldOutModal.hidden);
    }

    function isModalAlertGlowEnabled() {
      return !!(els.soldOutModal && els.soldOutModal.dataset.alertGlowEnabled === 'true');
    }

    function triggerModalShake() {
      if (!els.soldOutModalDialog) return;

      els.soldOutModalDialog.classList.remove('is-shaking');
      els.soldOutModalDialog.classList.remove('is-alert-glow');

      void els.soldOutModalDialog.offsetWidth;

      els.soldOutModalDialog.classList.add('is-shaking');

      if (isModalAlertGlowEnabled()) {
        els.soldOutModalDialog.classList.add('is-alert-glow');
      }

      if (state.modalShakeTimer) {
        clearTimeout(state.modalShakeTimer);
      }

      state.modalShakeTimer = setTimeout(function () {
        if (els.soldOutModalDialog) {
          els.soldOutModalDialog.classList.remove('is-shaking');
          els.soldOutModalDialog.classList.remove('is-alert-glow');
        }
      }, 560);
    }

    function parsePrice(value) {
      if (value === null || value === undefined || value === '') return 0;
      const cleaned = String(value).replace(/[^0-9.-]/g, '');
      return parseFloat(cleaned) || 0;
    }

    function parseDiscountValue(rawValue, subtotal) {
      const value = String(rawValue || '').trim();
      if (!value) return 0;

      const percentMatch = value.match(/^([0-9]+(?:\.[0-9]+)?)\s*%$/);
      if (percentMatch) {
        const percent = parseFloat(percentMatch[1]) || 0;
        return Math.max((Number(subtotal) || 0) * (percent / 100), 0);
      }

      return parsePrice(value);
    }

    function formatMoney(value) {
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: config.currencyCode || 'USD'
        }).format(value);
      } catch (error) {
        return `$${Number(value).toFixed(2)}`;
      }
    }

    function syncCTAVisualStates(options) {
      const opts = options || {};
      const isDisabled = !!opts.disabled;
      const isBusy = !!opts.busy;
      const isSuccess = !!opts.success;

      [els.desktopCTA, els.mobileCTA].forEach(function (button) {
        if (!button) return;

        button.disabled = isDisabled;
        button.classList.remove('is-disabled', 'is-busy', 'is-success');

        if (isDisabled) button.classList.add('is-disabled');
        if (isBusy) button.classList.add('is-busy');
        if (isSuccess) button.classList.add('is-success');
      });
    }

    function attachDesktopCTAGlow(button) {
      if (!button || button.dataset.glowBound === 'true') return;
      button.dataset.glowBound = 'true';

      function updateGlowPosition(event) {
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        button.style.setProperty('--wb-glow-x', `${x}px`);
        button.style.setProperty('--wb-glow-y', `${y}px`);
      }

      button.addEventListener('mousemove', function (event) {
        if (
          button.classList.contains('is-disabled') ||
          button.classList.contains('is-busy') ||
          button.classList.contains('is-success') ||
          button.disabled
        ) return;

        updateGlowPosition(event);
      });

      button.addEventListener('mouseenter', function (event) {
        updateGlowPosition(event);
      });
    }

    function normalizeTierList(tiers, minimumCount) {
      const minCount = typeof minimumCount === 'number' ? minimumCount : 1;
      return (Array.isArray(tiers) ? tiers : [])
        .map(function (tier) {
          return {
            count: Number(tier.count) || 0,
            amount: parsePrice(tier.amount),
            code: String(tier.code || '').trim()
          };
        })
        .filter(function (tier) {
          return tier.count >= minCount;
        })
        .sort(function (a, b) {
          return a.count - b.count;
        });
    }

    function getNormalizedDiscountTiers() {
      return normalizeTierList(config.discountTiers, 2);
    }

    function getNormalizedAccessoryDiscountTiers() {
      return normalizeTierList(config.accessoryDiscountTiers, 1);
    }

    function getMatchedTierByCount(tiers, count, maxCap) {
      const normalizedTiers = Array.isArray(tiers) ? tiers : [];
      if (!normalizedTiers.length) return null;

      const cap = typeof maxCap === 'number' ? maxCap : null;
      const effectiveCount = cap ? Math.min(Number(count) || 0, cap) : (Number(count) || 0);

      let matched = null;

      normalizedTiers.forEach(function (tier) {
        if (effectiveCount >= tier.count) {
          matched = tier;
        }
      });

      return matched;
    }

    function getNextTierByCount(tiers, count) {
      const normalizedTiers = Array.isArray(tiers) ? tiers : [];
      const currentCount = Number(count) || 0;

      for (let i = 0; i < normalizedTiers.length; i += 1) {
        if (normalizedTiers[i].count > currentCount) return normalizedTiers[i];
      }

      return null;
    }

    function getDiscountEligibleItems(mergedItems) {
      return (Array.isArray(mergedItems) ? mergedItems : []).filter(function (item) {
        return item.type !== 'bundle';
      });
    }

    function getCoreAndUpgradePresence(mergedItems) {
      const items = getDiscountEligibleItems(mergedItems);

      return {
        hasCore: items.some(function (item) { return item.type === 'core'; }),
        hasUpgrade: items.some(function (item) { return item.type === 'upgrade'; })
      };
    }

    function getBundleDiscountInfo(mergedItems) {
      const items = Array.isArray(mergedItems) ? mergedItems : [];
      const bundleItem = items.find(function (item) {
        return item.type === 'bundle';
      });

      if (!bundleItem) return null;

      const subtotal = items.reduce(function (sum, item) {
        return sum + parsePrice(item.price);
      }, 0);

      const rawDiscountValue = bundleItem.bundleDiscountAmountRaw || bundleItem.bundleDiscountAmount || '0';
      const amount = parseDiscountValue(rawDiscountValue, subtotal);
      const code = String(bundleItem.bundleDiscountCode || '').trim();

      if (amount <= 0 && !code) return null;

      return {
        amount: amount,
        code: code,
        source: 'bundle',
        rawValue: rawDiscountValue
      };
    }

    function getMainDiscountInfo(mergedItems) {
      const eligibleItems = getDiscountEligibleItems(mergedItems);
      const presence = getCoreAndUpgradePresence(mergedItems);

      if (!presence.hasCore || !presence.hasUpgrade) return null;

      const mainTier = getMatchedTierByCount(getNormalizedDiscountTiers(), eligibleItems.length, 7);
      if (!mainTier) return null;

      return {
        amount: parsePrice(mainTier.amount),
        code: String(mainTier.code || '').trim(),
        source: 'main'
      };
    }

    function getBaseSetupDiscountInfo(mergedItems) {
      const presence = getCoreAndUpgradePresence(mergedItems);

      if (!presence.hasCore && !presence.hasUpgrade) return null;

      const amountRaw = config.baseSetupDiscount ? config.baseSetupDiscount.amount : '0';
      const code = config.baseSetupDiscount ? String(config.baseSetupDiscount.code || '').trim() : '';

      const eligibleItems = getDiscountEligibleItems(mergedItems);
      const subtotal = eligibleItems.reduce(function (sum, item) {
        return sum + parsePrice(item.price);
      }, 0);

      const amount = parseDiscountValue(amountRaw, subtotal);

      if (amount <= 0 && !code) return null;

      return {
        amount: amount,
        code: code,
        source: 'base-setup',
        rawValue: amountRaw
      };
    }

    function getAccessoryOnlyDiscountInfo(mergedItems) {
      const items = getDiscountEligibleItems(mergedItems);
      const hasCore = items.some(function (item) { return item.type === 'core'; });
      const hasUpgrade = items.some(function (item) { return item.type === 'upgrade'; });
      const accessoryItems = items.filter(function (item) { return item.type === 'accessory'; });

      if (hasCore || hasUpgrade || !accessoryItems.length) return null;

      const accessoryTier = getMatchedTierByCount(
        getNormalizedAccessoryDiscountTiers(),
        accessoryItems.length,
        5
      );

      if (!accessoryTier) return null;

      return {
        amount: parsePrice(accessoryTier.amount),
        code: String(accessoryTier.code || '').trim(),
        source: 'accessory'
      };
    }

    function getEffectiveDiscountInfo(mergedItems) {
      const bundleDiscount = getBundleDiscountInfo(mergedItems);
      if (bundleDiscount) return bundleDiscount;

      const mainDiscount = getMainDiscountInfo(mergedItems);
      if (mainDiscount) return mainDiscount;

      const baseSetupDiscount = getBaseSetupDiscountInfo(mergedItems);
      if (baseSetupDiscount) return baseSetupDiscount;

      return getAccessoryOnlyDiscountInfo(mergedItems);
    }

    function getUpsellHintInfo(mergedItems) {
      const hasBundle = (Array.isArray(mergedItems) ? mergedItems : []).some(function (item) {
        return item.type === 'bundle';
      });

      if (hasBundle) return null;

      const items = getDiscountEligibleItems(mergedItems);
      const presence = getCoreAndUpgradePresence(mergedItems);
      const accessoryCount = items.filter(function (item) { return item.type === 'accessory'; }).length;
      const totalCount = items.length;

      if (!presence.hasCore && !presence.hasUpgrade && accessoryCount > 0) {
        const accessoryTiers = getNormalizedAccessoryDiscountTiers();
        const nextAccessoryTier = getNextTierByCount(accessoryTiers, Math.min(accessoryCount, 5));

        if (!nextAccessoryTier || nextAccessoryTier.amount <= 0) return null;

        return {
          source: 'accessory',
          targetCount: nextAccessoryTier.count,
          amount: parsePrice(nextAccessoryTier.amount),
          text: `Buy ${nextAccessoryTier.count} accessories, save ${formatMoney(nextAccessoryTier.amount)}`
        };
      }

      if (!(presence.hasCore && presence.hasUpgrade)) {
        return null;
      }

      const mainTiers = getNormalizedDiscountTiers();
      const nextMainTier = getNextTierByCount(mainTiers, Math.min(totalCount, 7));

      if (!nextMainTier || nextMainTier.amount <= 0) return null;

      return {
        source: 'main',
        targetCount: nextMainTier.count,
        amount: parsePrice(nextMainTier.amount),
        text: `Buy ${nextMainTier.count} items, save ${formatMoney(nextMainTier.amount)}`
      };
    }

    function renderUpsellHint(mergedItems) {
      const hintInfo = getUpsellHintInfo(mergedItems);
      const hintText = hintInfo ? hintInfo.text : '';

      [els.desktopUpsellHint, els.mobileUpsellHint].forEach(function (el) {
        if (!el) return;
        el.hidden = !hintText;
        el.textContent = hintText;
      });
    }

    function selectTextFallback(text) {
      const temp = document.createElement('input');
      temp.type = 'text';
      temp.value = text;
      temp.setAttribute('readonly', '');
      temp.style.position = 'fixed';
      temp.style.top = '-9999px';
      temp.style.left = '-9999px';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.focus();
      temp.select();
      temp.setSelectionRange(0, temp.value.length);
      return temp;
    }

    function visuallySelectButtonText(button) {
      if (!button) return;

      const selection = window.getSelection();
      if (!selection) return;

      const range = document.createRange();
      range.selectNodeContents(button);
      selection.removeAllRanges();
      selection.addRange(range);

      setTimeout(function () {
        try {
          selection.removeAllRanges();
        } catch (error) {}
      }, 1200);
    }

    async function copyDiscountCode(code, button) {
      if (!code) return false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          return true;
        }
      } catch (error) {}

      try {
        const temp = selectTextFallback(code);
        const success = document.execCommand('copy');
        document.body.removeChild(temp);
        if (success) return true;
      } catch (error) {}

      try {
        const temp = document.createElement('textarea');
        temp.value = code;
        temp.setAttribute('readonly', '');
        temp.style.position = 'fixed';
        temp.style.top = '-9999px';
        temp.style.left = '-9999px';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.focus();
        temp.select();
        temp.setSelectionRange(0, temp.value.length);

        const success = document.execCommand('copy');
        document.body.removeChild(temp);
        if (success) return true;
      } catch (error) {}

      visuallySelectButtonText(button);
      return false;
    }

    function setCopiedState(code, success) {
      state.copiedCode = success ? (code || '') : '';

      if (els.discountCodeText) {
        const currentCode = els.discountCodeText.dataset.code || '';
        if (currentCode === code) {
          els.discountCodeText.textContent = success ? 'COPIED' : currentCode || 'COPY CODE';
        }
      }

      if (els.mobileDiscountCodeText) {
        const currentCode = els.mobileDiscountCodeText.dataset.code || '';
        if (currentCode === code) {
          els.mobileDiscountCodeText.textContent = success ? 'COPIED' : currentCode || 'COPY CODE';
        }
      }

      if (els.discountCodeBtn) {
        els.discountCodeBtn.classList.toggle('is-copied', !!success);
      }

      if (els.mobileDiscountCodeBtn) {
        els.mobileDiscountCodeBtn.classList.toggle('is-copied', !!success);
      }

      setTimeout(function () {
        state.copiedCode = '';
        renderDiscountCodeState();
      }, success ? 1800 : 1400);
    }

    function renderDiscountCodeState() {
      const desktopCode = els.discountCodeText ? els.discountCodeText.dataset.code || '' : '';
      const mobileCode = els.mobileDiscountCodeText ? els.mobileDiscountCodeText.dataset.code || '' : '';

      const desktopCopied = state.copiedCode && desktopCode === state.copiedCode;
      const mobileCopied = state.copiedCode && mobileCode === state.copiedCode;

      if (els.discountCodeBtn) {
        els.discountCodeBtn.classList.toggle('is-copied', !!desktopCopied);
      }

      if (els.mobileDiscountCodeBtn) {
        els.mobileDiscountCodeBtn.classList.toggle('is-copied', !!mobileCopied);
      }

      if (els.discountCodeText) {
        els.discountCodeText.textContent = desktopCopied ? 'COPIED' : desktopCode;
      }

      if (els.mobileDiscountCodeText) {
        els.mobileDiscountCodeText.textContent = mobileCopied ? 'COPIED' : mobileCode;
      }
    }

    function updateDiscountDisplays(discountInfo) {
      const hasDiscount = !!(discountInfo && discountInfo.amount > 0);
      const discountAmount = hasDiscount ? discountInfo.amount : 0;
      const code = discountInfo ? String(discountInfo.code || '').trim() : '';
      const isBundleDiscount = !!(discountInfo && discountInfo.source === 'bundle');

      if (els.bundleRow) {
        els.bundleRow.hidden = !hasDiscount;
      }

      if (els.bundleRowLabel) {
        els.bundleRowLabel.textContent = isBundleDiscount ? 'Bundle savings with code' : 'Discount';
      }

      if (els.discountValue) {
        els.discountValue.textContent = '-' + formatMoney(discountAmount);
      }

      if (els.mobileSavings) {
        els.mobileSavings.textContent = 'Save ' + formatMoney(discountAmount);
      }

      if (els.discountCodeWrap) {
        els.discountCodeWrap.hidden = !code;
      }

      if (els.mobileDiscountCodeWrap) {
        els.mobileDiscountCodeWrap.hidden = !code;
      }

      if (els.discountCodeText) {
        els.discountCodeText.dataset.code = code;
        els.discountCodeText.textContent = code;
      }

      if (els.mobileDiscountCodeText) {
        els.mobileDiscountCodeText.dataset.code = code;
        els.mobileDiscountCodeText.textContent = code;
      }

      if (els.discountNote) {
        els.discountNote.hidden = !(isBundleDiscount && code);
        els.discountNote.textContent = isBundleDiscount && code
          ? 'Use the discount code below at checkout to unlock this savings.'
          : '';
      }

      if (els.mobileDiscountNote) {
        els.mobileDiscountNote.hidden = !(isBundleDiscount && code);
        els.mobileDiscountNote.textContent = isBundleDiscount && code
          ? 'Use code at checkout to unlock savings.'
          : '';
      }

      renderDiscountCodeState();
    }

    function getButtonSelector(type) {
      if (type === 'accessory') return '.workspace-accessory__button';
      if (type === 'bundle') return '.workspace-bundle-card__button';
      return '.workspace-card__button';
    }

    function getDefaultText(card) {
      const type = card.dataset.type;
      if (type === 'core') return card.dataset.defaultText || 'Add Core Setup';
      if (type === 'upgrade') return card.dataset.defaultText || 'Add Upgrade';
      if (type === 'bundle') return card.dataset.defaultText || 'Choose Go Pack';
      return card.dataset.defaultText || 'Add Accessory';
    }

    function getVariants(card) {
      try {
        return JSON.parse(card.dataset.productVariants || '[]');
      } catch (error) {
        return [];
      }
    }

    function getVariantSelect(card) {
      if (card.dataset.type === 'bundle') return card.querySelector('[data-bundle-variant-select]');
      return card.querySelector('.workspace-card__variant-select');
    }

    function getActiveVariant(card) {
      const variants = getVariants(card);
      const select = getVariantSelect(card);
      const selectedId = select ? String(select.value) : String(card.dataset.initialVariantId || '');

      let variant = variants.find(function (item) {
        return String(item.id) === selectedId;
      });

      if (!variant && variants.length) variant = variants[0];

      if (!variant) {
        return {
          id: card.dataset.initialVariantId || '',
          title: 'Default',
          price: 0,
          available: true
        };
      }

      return variant;
    }

    function isVariantAvailable(card) {
      const variant = getActiveVariant(card);
      return !!variant.available;
    }

    function setCardVariantById(card, variantId) {
      const select = getVariantSelect(card);
      if (!select) return false;

      const option = Array.from(select.options).find(function (opt) {
        return String(opt.value) === String(variantId);
      });

      if (!option) return false;

      select.value = String(variantId);
      updateCardPriceDisplay(card);
      return true;
    }

    function updateCardPriceDisplay(card) {
      const variant = getActiveVariant(card);
      const type = card.dataset.type;
      const priceEl = type === 'bundle'
        ? card.querySelector('[data-bundle-price-display]')
        : card.querySelector('[data-price-display]');

      if (priceEl) {
        if (type === 'bundle') {
          priceEl.textContent = `${formatMoney(variant.price)}`;
        } else {
          priceEl.textContent = `+${formatMoney(variant.price)}`;
        }
      }
    }

    function normalizeText(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function isNoConfigVariantTitle(title) {
      const normalized = normalizeText(title);
      if (!normalized) return false;

      const exactLikePatterns = [
        /\bnon prescription\b/,
        /\bnon-prescription\b/,
        /\bno prescription\b/,
        /\bwithout prescription\b/,
        /\bplano\b/,
        /\bframe only\b/,
        /\bno lens\b/,
        /\bno lenses\b/,
        /\bstandard lens\b/,
        /\bstandard lenses\b/,
        /\b0\.00\b/
      ];

      const simpleNoPatterns = [
        /^no$/,
        /^none$/,
        /^without$/,
        /^no lens$/,
        /^no lenses$/,
        /^frame only$/
      ];

      if (exactLikePatterns.some(function (pattern) { return pattern.test(normalized); })) return true;
      if (simpleNoPatterns.some(function (pattern) { return pattern.test(normalized); })) return true;

      return false;
    }

    function getResolvedRequiresConfiguration(card, variantTitle) {
      const blockRequiresConfiguration = card.dataset.requiresConfiguration === 'true';
      if (!blockRequiresConfiguration) return false;
      return !isNoConfigVariantTitle(variantTitle);
    }

    function getCardConfigurationState(card) {
      const variant = getActiveVariant(card);
      const requiresConfiguration = getResolvedRequiresConfiguration(card, variant.title || '');

      return {
        variant: variant,
        requiresConfiguration: requiresConfiguration,
        configurationUrl: card.dataset.configurationUrl || '',
        isAvailable: !!variant.available
      };
    }

    function getItemConfigurationState(item) {
      return {
        requiresConfiguration: !!item.requiresConfiguration,
        configurationUrl: String(item.configurationUrl || '').trim()
      };
    }

    function buildConfigurationUrl(configurationUrl, variantId) {
      const baseUrl = String(configurationUrl || '').trim();
      const resolvedVariantId = String(variantId || '').trim();

      if (!baseUrl) return '';

      try {
        const url = new URL(baseUrl, window.location.origin);

        if (resolvedVariantId) {
          url.searchParams.set('variant', resolvedVariantId);
        }

        if (url.origin === window.location.origin) {
          return url.pathname + url.search + url.hash;
        }

        return url.toString();
      } catch (error) {
        if (!resolvedVariantId) return baseUrl;

        const hasQuery = baseUrl.indexOf('?') > -1;
        const hasVariant = /([?&])variant=/.test(baseUrl);

        if (hasVariant) {
          return baseUrl.replace(/([?&])variant=[^&#]*/g, '$1variant=' + encodeURIComponent(resolvedVariantId));
        }

        return baseUrl + (hasQuery ? '&' : '?') + 'variant=' + encodeURIComponent(resolvedVariantId);
      }
    }

    function getItemConfigurationRedirectUrl(item) {
      if (!item) return '';
      return buildConfigurationUrl(item.configurationUrl, item.variantId);
    }

    function getRestrictedSelectedItems(items) {
      return (Array.isArray(items) ? items : []).filter(function (item) {
        const configurationState = getItemConfigurationState(item);
        return configurationState.requiresConfiguration;
      });
    }

    function getBundleIncludeLabels() {
      const labels = [];
      if (!els.bundleFallbackSection) return labels;

      const includeItems = els.bundleFallbackSection.querySelectorAll('[data-bundle-include-item]');
      includeItems.forEach(function (item) {
        const label = String(item.getAttribute('data-bundle-include-label') || '').trim();
        if (label) labels.push(label);
      });

      return labels;
    }

    function getItemFromCard(card, source, quantity, lineItemKey) {
      const configurationState = getCardConfigurationState(card);
      const variant = configurationState.variant;

      return {
        key: card.dataset.itemKey,
        type: card.dataset.type,
        title: card.dataset.title || 'Untitled',
        productTitle: card.dataset.productTitle || card.dataset.title || 'Untitled',
        benefit: card.dataset.benefit || card.dataset.title || 'Item',
        image: card.dataset.image || '',
        price: parsePrice(variant.price),
        variantId: variant.id || '',
        variantTitle: variant.title || '',
        requiresConfiguration: configurationState.requiresConfiguration,
        configurationUrl: configurationState.configurationUrl,
        source: source || 'selected',
        quantity: quantity || 1,
        cartLineKey: lineItemKey || '',
        card: card,
        includedItems: card.dataset.type === 'bundle' ? getBundleIncludeLabels() : [],
        bundleDiscountAmount: card.dataset.type === 'bundle' ? parsePrice(card.dataset.bundleDiscountAmount) : 0,
        bundleDiscountAmountRaw: card.dataset.type === 'bundle' ? String(card.dataset.bundleDiscountAmount || '').trim() : '',
        bundleDiscountCode: card.dataset.type === 'bundle' ? String(card.dataset.bundleDiscountCode || '').trim() : ''
      };
    }

    function getAccessoryProgressStats(mergedItems) {
      const accessoryCards = cards.filter(function (card) {
        return card.dataset.type === 'accessory';
      });

      const selectedAccessoryKeys = mergedItems
        .filter(function (item) { return item.type === 'accessory'; })
        .map(function (item) { return item.key; });

      const groupsMap = {};
      const standaloneCards = [];

      accessoryCards.forEach(function (card) {
        const matchEnabled = card.dataset.progressMatchEnabled === 'true';
        const matchGroup = String(card.dataset.progressMatchGroup || '').trim();

        if (matchEnabled && matchGroup) {
          if (!groupsMap[matchGroup]) groupsMap[matchGroup] = [];
          groupsMap[matchGroup].push(card);
        } else {
          standaloneCards.push(card);
        }
      });

      let total = standaloneCards.length;
      let completed = 0;

      standaloneCards.forEach(function (card) {
        if (selectedAccessoryKeys.indexOf(card.dataset.itemKey) > -1) {
          completed += 1;
        }
      });

      Object.keys(groupsMap).forEach(function (groupKey) {
        const groupCards = groupsMap[groupKey];
        total += 1;

        const hasAnySelected = groupCards.some(function (card) {
          return selectedAccessoryKeys.indexOf(card.dataset.itemKey) > -1;
        });

        if (hasAnySelected) completed += 1;
      });

      return {
        total: Math.max(total, 1),
        completed: completed
      };
    }

    function hexToRgb(hex) {
      if (!hex) return null;
      let normalized = hex.replace('#', '').trim();

      if (normalized.length === 3) {
        normalized = normalized.split('').map(function (char) {
          return char + char;
        }).join('');
      }

      if (normalized.length !== 6) return null;

      const int = parseInt(normalized, 16);
      return {
        r: (int >> 16) & 255,
        g: (int >> 8) & 255,
        b: int & 255
      };
    }

    function rgbStringToRgb(rgbString) {
      if (!rgbString) return null;
      const match = rgbString.match(/\d+/g);
      if (!match || match.length < 3) return null;

      return {
        r: parseInt(match[0], 10),
        g: parseInt(match[1], 10),
        b: parseInt(match[2], 10)
      };
    }

    function getLuminance(rgb) {
      if (!rgb) return 0;

      const channels = [rgb.r, rgb.g, rgb.b].map(function (value) {
        const channel = value / 255;
        return channel <= 0.03928
          ? channel / 12.92
          : Math.pow((channel + 0.055) / 1.055, 2.4);
      });

      return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
    }

    function getContrastTextColor(bgColor) {
      let rgb = null;
      if (bgColor.startsWith('#')) rgb = hexToRgb(bgColor);
      else if (bgColor.startsWith('rgb')) rgb = rgbStringToRgb(bgColor);
      if (!rgb) return '#ffffff';

      const luminance = getLuminance(rgb);
      return luminance > 0.42 ? '#111111' : '#ffffff';
    }

    function applyCTAContrastColors() {
      const ctaButtons = [els.desktopCTA, els.mobileCTA].filter(Boolean);

      ctaButtons.forEach(function (button) {
        const computed = window.getComputedStyle(button);
        const bgColor = computed.backgroundColor && computed.backgroundColor !== 'rgba(0, 0, 0, 0)'
          ? computed.backgroundColor
          : '#111827';

        const safeTextColor = getContrastTextColor(bgColor);
        button.style.setProperty('--wb-cta-bg', bgColor);
        button.style.setProperty('--wb-cta-text', safeTextColor);
      });
    }

    function resetMobileCanvasScaling() {
      if (!els.viewport || !els.canvas) return;
      els.viewport.style.height = '';
      els.canvas.style.width = '';
      els.canvas.style.transform = '';
    }

    function findSelectedIndexByKey(key) {
      return state.selectedItems.findIndex(function (item) {
        return item.key === key;
      });
    }

    function updateCardUI(card, selected) {
      const type = card.dataset.type;
      const button = card.querySelector(getButtonSelector(type));

      if (selected) {
        card.classList.add('is-selected');
        if (button) button.textContent = 'Added';
      } else {
        const existsInCart = state.cartItems.some(function (item) {
          return item.key === card.dataset.itemKey;
        });

        if (!existsInCart) {
          card.classList.remove('is-selected');
          if (button) button.textContent = getDefaultText(card);
        } else {
          card.classList.add('is-selected');
          if (button) button.textContent = 'Added';
        }
      }
    }

    function markCardInCart(card, inCart) {
      const type = card.dataset.type;
      const button = card.querySelector(getButtonSelector(type));

      if (inCart) {
        card.classList.add('is-selected');
        if (button) button.textContent = 'Added';
      } else {
        const stillSelectedLocally = state.selectedItems.some(function (item) {
          return item.key === card.dataset.itemKey;
        });

        if (!stillSelectedLocally) {
          card.classList.remove('is-selected');
          if (button) button.textContent = getDefaultText(card);
        }
      }
    }

    function syncSelectedItemVariant(card) {
      const key = card.dataset.itemKey;
      const index = findSelectedIndexByKey(key);
      if (index === -1) return;

      state.selectedItems[index] = getItemFromCard(
        card,
        state.selectedItems[index].source || 'selected',
        state.selectedItems[index].quantity || 1,
        state.selectedItems[index].cartLineKey || ''
      );

      render();
    }

    function clearBundleSelection(silent) {
      state.selectedItems = state.selectedItems.filter(function (item) {
        if (item.type !== 'bundle') return true;
        updateCardUI(item.card, false);
        return false;
      });

      if (!silent) render();
    }

    function clearCoreAndUpgradeSelectionsForBundle(silent) {
      state.selectedItems = state.selectedItems.filter(function (item) {
        if (item.type === 'core' || item.type === 'upgrade') {
          updateCardUI(item.card, false);
          return false;
        }
        return true;
      });

      if (!silent) render();
    }

    function selectCard(card, silent) {
      const item = getItemFromCard(card, 'selected');
      if (!item.key) return;
      if (findSelectedIndexByKey(item.key) > -1) return;

      if (item.type === 'core') {
        clearBundleSelection(true);
        state.selectedItems
          .filter(function (selected) { return selected.type === 'core'; })
          .forEach(function (selected) {
            removeLocalOnlyByKey(selected.key, true);
          });
      }

      if (item.type === 'upgrade') {
        clearBundleSelection(true);
      }

      if (item.type === 'bundle') {
        clearCoreAndUpgradeSelectionsForBundle(true);
        clearBundleSelection(true);
      }

      state.selectedItems.push(item);
      updateCardUI(card, true);

      if (!silent) render();
    }

    function removeLocalOnlyByKey(key, silent) {
      const index = findSelectedIndexByKey(key);
      if (index === -1) return;

      const item = state.selectedItems[index];
      state.selectedItems.splice(index, 1);
      updateCardUI(item.card, false);

      if (!silent) render();
    }

    function toggleCard(card) {
      if (state.isSubmitting || state.isRemoving) return;

      const key = card.dataset.itemKey;
      if (!key) return;

      if (card.dataset.type === 'upgrade' && !isVariantAvailable(card)) {
        openSoldOutFlow(card);
        return;
      }

      if (card.dataset.type === 'bundle' && !isVariantAvailable(card)) {
        return;
      }

      const existingIndex = findSelectedIndexByKey(key);
      if (existingIndex > -1) {
        removeLocalOnlyByKey(key, false);
        return;
      }

      selectCard(card, false);
    }

    function makeEmpty(text) {
      const div = document.createElement('div');
      div.className = 'workspace-summary__benefit is-empty';
      div.textContent = text;
      return div;
    }

    function getMergedItems() {
      const merged = [];

      state.cartItems.forEach(function (item) {
        merged.push(item);
      });

      state.selectedItems.forEach(function (item) {
        const exists = merged.some(function (cartItem) {
          return cartItem.key === item.key;
        });
        if (!exists) merged.push(item);
      });

      const hasBundle = merged.some(function (item) {
        return item.type === 'bundle';
      });

      if (hasBundle) {
        return merged.filter(function (item) {
          return item.type !== 'core' && item.type !== 'upgrade';
        });
      }

      return merged;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function getSummaryThumbMarkup(item) {
      if (item.image) {
        return `
          <div class="workspace-summary__benefit-thumb">
            <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.productTitle || item.title)}" loading="lazy">
          </div>
        `;
      }

      return `
        <div class="workspace-summary__benefit-thumb workspace-summary__benefit-thumb--placeholder">
          Item
        </div>
      `;
    }

    function getBundleSubitemsMarkup(item) {
      const includedItems = Array.isArray(item.includedItems) ? item.includedItems : [];
      if (!includedItems.length) return '';

      return `
        <div class="workspace-summary__benefit-subitems">
          ${includedItems.map(function (subitem) {
            return `<span class="workspace-summary__benefit-subitem">${escapeHtml(subitem)}</span>`;
          }).join('')}
        </div>
      `;
    }

    function renderGroup(container, items, emptyText) {
      if (!container) return;

      container.innerHTML = '';

      if (!items.length) {
        container.appendChild(makeEmpty(emptyText));
        return;
      }

      items.forEach(function (item) {
        let statusText = 'Selected';

        if (item.requiresConfiguration) statusText = 'Requires configuration';
        else if (item.variantTitle && item.variantTitle !== 'Default Title') statusText = item.variantTitle;

        const row = document.createElement('div');
        row.className = 'workspace-summary__benefit';
        row.setAttribute('data-remove-key', item.key);
        row.innerHTML = `
          <div class="workspace-summary__benefit-main">
            ${getSummaryThumbMarkup(item)}
            <div class="workspace-summary__benefit-copy">
              <div class="workspace-summary__benefit-title">${escapeHtml(item.productTitle || item.title)}</div>
              <div class="workspace-summary__benefit-label">
                <span class="workspace-summary__benefit-status">${escapeHtml(statusText)}</span>
              </div>
              ${item.type === 'bundle' ? getBundleSubitemsMarkup(item) : ''}
            </div>
          </div>
          <button class="workspace-summary__remove" type="button">Remove</button>
        `;
        container.appendChild(row);
      });
    }

    function ensureSegmentedProgress() {
      if (!els.progressFill) return null;

      const progressBar = els.progressFill.parentElement;
      if (!progressBar) return null;

      const groupedCards = {
        core: cards.filter(function (card) { return card.dataset.type === 'core'; }),
        upgrade: cards.filter(function (card) { return card.dataset.type === 'upgrade'; })
      };

      const accessoryProgress = getAccessoryProgressStats(getMergedItems());

      const groupConfig = [
        { key: 'core', count: groupedCards.core.length || 1 },
        { key: 'upgrade', count: groupedCards.upgrade.length || 1 },
        { key: 'accessory', count: accessoryProgress.total || 1 }
      ];

      const currentSignature = progressBar.dataset.progressSignature || '';
      const nextSignature = groupConfig.map(function (group) {
        return group.key + ':' + group.count;
      }).join('|');

      if (currentSignature !== nextSignature) {
        progressBar.querySelectorAll('.workspace-summary__progress-group').forEach(function (group) {
          group.remove();
        });

        groupConfig.forEach(function (group) {
          const groupEl = document.createElement('div');
          groupEl.className = 'workspace-summary__progress-group';
          groupEl.setAttribute('data-group', group.key);

          for (let i = 0; i < group.count; i += 1) {
            const segment = document.createElement('span');
            segment.className = 'workspace-summary__progress-segment';
            segment.setAttribute('data-group', group.key);
            segment.setAttribute('data-index', String(i));
            segment.setAttribute('aria-hidden', 'true');
            groupEl.appendChild(segment);
          }

          progressBar.appendChild(groupEl);
        });

        progressBar.dataset.progressSignature = nextSignature;
      }

      return progressBar;
    }

    function updateSegmentedProgress() {
      const progressBar = ensureSegmentedProgress();
      if (!progressBar) return;

      const mergedItems = getMergedItems();
      const hasBundle = mergedItems.some(function (item) { return item.type === 'bundle'; });
      const accessoryProgress = getAccessoryProgressStats(mergedItems);

      const totals = {
        core: Math.max(cards.filter(function (card) { return card.dataset.type === 'core'; }).length, 1),
        upgrade: Math.max(cards.filter(function (card) { return card.dataset.type === 'upgrade'; }).length, 1),
        accessory: accessoryProgress.total
      };

      const counts = {
        core: hasBundle ? totals.core : mergedItems.filter(function (item) { return item.type === 'core'; }).length,
        upgrade: hasBundle ? totals.upgrade : mergedItems.filter(function (item) { return item.type === 'upgrade'; }).length,
        accessory: hasBundle ? totals.accessory : accessoryProgress.completed
      };

      ['core', 'upgrade', 'accessory'].forEach(function (groupKey) {
        const groupEl = progressBar.querySelector('.workspace-summary__progress-group[data-group="' + groupKey + '"]');
        if (!groupEl) return;

        const segments = Array.from(groupEl.querySelectorAll('.workspace-summary__progress-segment'));
        const shouldForceBundleActive = hasBundle;

        groupEl.classList.toggle('is-bundle-active', shouldForceBundleActive);

        segments.forEach(function (segment, index) {
          segment.classList.toggle('is-active', index < counts[groupKey]);
        });
      });

      if (els.progressText) {
        if (hasBundle) {
          els.progressText.textContent = 'Bundle selected · Complete setup included';
        } else {
          els.progressText.textContent =
            `Core ${counts.core}/${totals.core} · Upgrades ${counts.upgrade}/${totals.upgrade} · Accessories ${counts.accessory}/${totals.accessory}`;
        }
      }
    }

    function setCTAButtonText(button, textNode, text) {
      if (textNode) textNode.textContent = text;
      else if (button) button.textContent = text;
    }

    function renderCTA(total) {
      const mergedItems = getMergedItems();
      const selectedOnlyItems = mergedItems.filter(function (item) {
        return !state.cartItems.some(function (cartItem) {
          return cartItem.key === item.key;
        });
      });

      const count = mergedItems.length;
      const hasRestrictedItems = getRestrictedSelectedItems(selectedOnlyItems).length > 0;

      let desktopText = 'Select Products to Continue';
      let mobileText = 'Add Workspace to Cart';
      let disabled = selectedOnlyItems.length === 0;

      if (count > 0) {
        if (hasRestrictedItems) {
          desktopText = `Continue to Configure · ${selectedOnlyItems.length} ${selectedOnlyItems.length === 1 ? 'Item' : 'Items'}`;
          mobileText = `Configure · ${selectedOnlyItems.length}`;
        } else if (selectedOnlyItems.length > 0) {
          desktopText = `Add ${selectedOnlyItems.length} ${selectedOnlyItems.length === 1 ? 'Item' : 'Items'} · ${formatMoney(total)}`;
          mobileText = 'Add Workspace to Cart';
        } else {
          desktopText = 'Already Added';
          mobileText = 'Added';
          disabled = true;
        }
      }

      if (els.desktopCTA) {
        setCTAButtonText(els.desktopCTA, els.desktopCTAText, desktopText);
      }

      if (els.mobileCTA) {
        setCTAButtonText(els.mobileCTA, els.mobileCTAText, mobileText);
      }

      syncCTAVisualStates({
        disabled: state.isSubmitting || state.isRemoving || disabled,
        busy: state.isSubmitting || state.isRemoving,
        success: !state.isSubmitting && !state.isRemoving && count > 0 && selectedOnlyItems.length === 0
      });

      applyCTAContrastColors();
    }

    function render() {
      const mergedItems = getMergedItems();

      const bundleItems = mergedItems.filter(function (item) { return item.type === 'bundle'; });
      const coreItems = mergedItems.filter(function (item) { return item.type === 'core'; });
      const upgradeItems = mergedItems.filter(function (item) { return item.type === 'upgrade'; });
      const accessoryItems = mergedItems.filter(function (item) { return item.type === 'accessory'; });

      renderGroup(els.bundleContainer, bundleItems, 'No bundle selected');
      renderGroup(els.coreContainer, coreItems, 'No core setup selected');
      renderGroup(els.upgradesContainer, upgradeItems, 'No upgrades selected');
      renderGroup(els.accessoriesContainer, accessoryItems, 'No accessories selected');

      const selectedOnlyItems = mergedItems.filter(function (item) {
        return !state.cartItems.some(function (cartItem) {
          return cartItem.key === item.key;
        });
      });

      const subtotal = selectedOnlyItems.reduce(function (sum, item) {
        return sum + item.price;
      }, 0);

      const discountInfo = getEffectiveDiscountInfo(mergedItems);
      const discount = discountInfo ? parsePrice(discountInfo.amount) : 0;
      const total = Math.max(subtotal - discount, 0);

      if (els.addonsPrice) els.addonsPrice.textContent = formatMoney(subtotal);
      if (els.totalPrice) els.totalPrice.textContent = formatMoney(total);
      if (els.mobileTotal) els.mobileTotal.textContent = formatMoney(total);

      updateDiscountDisplays(discountInfo);
      updateSegmentedProgress();
      renderUpsellHint(mergedItems);
      renderCTA(total);
      resetMobileCanvasScaling();
    }

    async function fetchCart() {
      try {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) throw new Error('Failed to fetch cart');
        return await response.json();
      } catch (error) {
        console.error('[Workspace Builder] cart fetch error:', error);
        return null;
      }
    }

    function buildCartItemsFromCartData(cart) {
      if (!cart || !cart.items) return [];

      const cartMappedItems = [];

      allSelectableCards.forEach(function (card) {
        const variants = getVariants(card);

        const matchedLineItem = cart.items.find(function (lineItem) {
          return variants.some(function (variant) {
            return String(variant.id) === String(lineItem.variant_id);
          });
        });

        if (!matchedLineItem) {
          markCardInCart(card, false);
          return;
        }

        setCardVariantById(card, matchedLineItem.variant_id);
        markCardInCart(card, true);

        const matchedVariant = variants.find(function (variant) {
          return String(variant.id) === String(matchedLineItem.variant_id);
        });

        const resolvedRequiresConfiguration = getResolvedRequiresConfiguration(card, matchedVariant ? matchedVariant.title : '');

        cartMappedItems.push({
          key: card.dataset.itemKey,
          type: card.dataset.type,
          title: card.dataset.title || 'Untitled',
          productTitle: card.dataset.productTitle || card.dataset.title || 'Untitled',
          benefit: card.dataset.benefit || card.dataset.title || 'Item',
          image: card.dataset.image || '',
          price: parsePrice(matchedVariant ? matchedVariant.price : 0),
          variantId: matchedLineItem.variant_id,
          variantTitle: matchedVariant ? matchedVariant.title : '',
          requiresConfiguration: resolvedRequiresConfiguration,
          configurationUrl: card.dataset.configurationUrl || '',
          source: 'cart',
          quantity: matchedLineItem.quantity || 1,
          cartLineKey: matchedLineItem.key || '',
          card: card,
          includedItems: card.dataset.type === 'bundle' ? getBundleIncludeLabels() : [],
          bundleDiscountAmount: card.dataset.type === 'bundle' ? parsePrice(card.dataset.bundleDiscountAmount) : 0,
          bundleDiscountAmountRaw: card.dataset.type === 'bundle' ? String(card.dataset.bundleDiscountAmount || '').trim() : '',
          bundleDiscountCode: card.dataset.type === 'bundle' ? String(card.dataset.bundleDiscountCode || '').trim() : ''
        });
      });

      allSelectableCards.forEach(function (card) {
        const exists = cartMappedItems.some(function (item) {
          return item.key === card.dataset.itemKey;
        });
        if (!exists) markCardInCart(card, false);
      });

      return cartMappedItems;
    }

    async function syncFromCart() {
      const cart = await fetchCart();
      if (!cart) return;
      state.cartItems = buildCartItemsFromCartData(cart);
      render();
    }

    async function removeCartLineByKey(lineKey) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });

      if (!response.ok) throw new Error('Failed to remove cart item');
      return await response.json();
    }

    async function handleRemoveItem(key) {
      if (state.isSubmitting || state.isRemoving) return;

      const cartItem = state.cartItems.find(function (item) {
        return item.key === key;
      });

      const selectedIndex = findSelectedIndexByKey(key);
      const localItem = selectedIndex > -1 ? state.selectedItems[selectedIndex] : null;

      if (cartItem) {
        state.isRemoving = true;
        render();

        try {
          await removeCartLineByKey(cartItem.cartLineKey);

          state.cartItems = state.cartItems.filter(function (item) {
            return item.key !== key;
          });

          if (selectedIndex > -1) state.selectedItems.splice(selectedIndex, 1);

          if (cartItem.card) {
            cartItem.card.classList.remove('is-selected');
            const button = cartItem.card.querySelector(getButtonSelector(cartItem.type));
            if (button) button.textContent = getDefaultText(cartItem.card);
          }

          render();
          await syncFromCart();
        } catch (error) {
          console.error('[Workspace Builder] remove cart item error:', error);
          render();
        } finally {
          state.isRemoving = false;
          render();
        }

        return;
      }

      if (localItem) removeLocalOnlyByKey(key, false);
    }

    async function submitToCart(triggerButton) {
      if (state.isSubmitting || state.isRemoving) return;

      const mergedItems = getMergedItems();
      const selectedOnlyItems = mergedItems.filter(function (item) {
        return !state.cartItems.some(function (cartItem) {
          return cartItem.key === item.key;
        });
      });

      const restrictedItems = getRestrictedSelectedItems(selectedOnlyItems);

      const directCartItems = selectedOnlyItems.filter(function (item) {
        return !item.requiresConfiguration && item.variantId;
      });

      if (restrictedItems.length) {
        state.isSubmitting = true;

        if (triggerButton === els.desktopCTA) {
          setCTAButtonText(els.desktopCTA, els.desktopCTAText, 'Redirecting...');
        }
        if (triggerButton === els.mobileCTA) {
          setCTAButtonText(els.mobileCTA, els.mobileCTAText, 'Redirecting...');
        }

        renderCTA(0);

        try {
          if (directCartItems.length) {
            const items = directCartItems.map(function (item) {
              return { id: Number(item.variantId), quantity: 1 };
            });

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });

            if (!response.ok) throw new Error('Failed to add normal items before redirect');
          }

          const firstRestricted = restrictedItems[0];
          const configurationUrl = getItemConfigurationRedirectUrl(firstRestricted);

          if (configurationUrl) {
            window.location.href = configurationUrl;
            return;
          }

          throw new Error('Restricted item missing configuration URL');
        } catch (error) {
          console.error('[Workspace Builder] restricted flow error:', error);
          state.isSubmitting = false;
          render();

          if (els.desktopCTA) setCTAButtonText(els.desktopCTA, els.desktopCTAText, 'Something went wrong. Try again');
          if (els.mobileCTA) setCTAButtonText(els.mobileCTA, els.mobileCTAText, 'Try Again');
          applyCTAContrastColors();
        }

        return;
      }

      const items = directCartItems.map(function (item) {
        return { id: Number(item.variantId), quantity: 1 };
      });

      if (!items.length) return;

      state.isSubmitting = true;

      if (triggerButton === els.desktopCTA) {
        setCTAButtonText(els.desktopCTA, els.desktopCTAText, 'Adding...');
      }
      if (triggerButton === els.mobileCTA) {
        setCTAButtonText(els.mobileCTA, els.mobileCTAText, 'Adding...');
      }

      renderCTA(0);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) throw new Error('Add to cart failed');

        if (els.desktopCTA) {
          setCTAButtonText(els.desktopCTA, els.desktopCTAText, 'Already Added');
        }
        if (els.mobileCTA) {
          setCTAButtonText(els.mobileCTA, els.mobileCTAText, 'Added');
        }

        syncCTAVisualStates({
          disabled: true,
          busy: false,
          success: true
        });

        await syncFromCart();
        window.location.href = '/cart';
      } catch (error) {
        console.error('[Workspace Builder] submit error:', error);
        state.isSubmitting = false;
        render();

        if (els.desktopCTA) setCTAButtonText(els.desktopCTA, els.desktopCTAText, 'Something went wrong. Try again');
        if (els.mobileCTA) setCTAButtonText(els.mobileCTA, els.mobileCTAText, 'Try Again');
        applyCTAContrastColors();
      }
    }

    function getFallbackDataFromCard(card) {
      if (!card) return null;

      const enabled = card.dataset.fallbackBundleEnabled === 'true';
      if (!enabled) return null;

      const variants = (function () {
        try {
          return JSON.parse(card.dataset.fallbackBundleProductVariants || '[]');
        } catch (error) {
          return [];
        }
      })();

      const variantId = card.dataset.fallbackBundleVariantId || '';
      const activeVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || variants[0] || null;

      if (!activeVariant) return null;

      return {
        title: card.dataset.fallbackBundleTitle || card.dataset.fallbackBundleProductTitle || '',
        subtitle: card.dataset.fallbackBundleSubtitle || '',
        cta: card.dataset.fallbackBundleCta || 'Get it with Go Pack',
        productTitle: card.dataset.fallbackBundleProductTitle || card.dataset.fallbackBundleTitle || '',
        variantId: activeVariant.id || '',
        image: card.dataset.fallbackBundleImage || '',
        price: parsePrice(activeVariant.price),
        variants: variants,
        requiresConfiguration: card.dataset.fallbackBundleRequiresConfiguration === 'true',
        configurationUrl: card.dataset.fallbackBundleConfigurationUrl || ''
      };
    }

    function getSectionDefaultFallbackData() {
      if (!els.bundleFallbackSection || !els.bundleCard) return null;

      let variants = [];
      try {
        variants = JSON.parse(els.bundleFallbackSection.dataset.defaultProductVariants || '[]');
      } catch (error) {}

      const variantId = els.bundleFallbackSection.dataset.defaultVariantId || '';
      const activeVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || variants[0] || null;

      if (!activeVariant) return null;

      return {
        title: els.bundleFallbackSection.dataset.defaultTitle || '',
        subtitle: els.bundleFallbackSection.dataset.defaultSubtitle || '',
        cta: els.bundleFallbackSection.dataset.defaultCta || 'Choose Go Pack',
        productTitle: els.bundleFallbackSection.dataset.defaultProductTitle || '',
        variantId: activeVariant.id || '',
        image: els.bundleFallbackSection.dataset.defaultImage || '',
        price: parsePrice(activeVariant.price),
        variants: variants,
        requiresConfiguration: els.bundleFallbackSection.dataset.defaultRequiresConfiguration === 'true',
        configurationUrl: els.bundleFallbackSection.dataset.defaultConfigurationUrl || ''
      };
    }

    function updateBundleCardFromFallbackData(data) {
      if (!els.bundleCard || !data) return;

      els.bundleCard.dataset.title = data.title || '';
      els.bundleCard.dataset.productTitle = data.productTitle || data.title || '';
      els.bundleCard.dataset.initialVariantId = data.variantId || '';
      els.bundleCard.dataset.productVariants = JSON.stringify(Array.isArray(data.variants) ? data.variants : []);
      els.bundleCard.dataset.requiresConfiguration = data.requiresConfiguration ? 'true' : 'false';
      els.bundleCard.dataset.configurationUrl = data.configurationUrl || '';

      if (data.image) {
        els.bundleCard.dataset.image = data.image;
      } else {
        els.bundleCard.dataset.image = '';
      }

      if (els.bundleTitle) {
        els.bundleTitle.textContent = data.title || '';
      }

      if (els.bundleSubtitle) {
        els.bundleSubtitle.textContent = data.subtitle || '';
      }

      if (els.bundleSelectBtn) {
        els.bundleSelectBtn.textContent = data.cta || getDefaultText(els.bundleCard);
        els.bundleCard.dataset.defaultText = data.cta || getDefaultText(els.bundleCard);
      }

      const imageEl = els.bundleCard.querySelector('.workspace-bundle-card__image');
      if (imageEl && data.image && imageEl.tagName === 'IMG') {
        imageEl.src = data.image;
        imageEl.alt = data.productTitle || data.title || '';
      }

      if (els.bundleVariantSelect) {
        els.bundleVariantSelect.innerHTML = '';
        (Array.isArray(data.variants) ? data.variants : []).forEach(function (variant, index) {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          option.dataset.price = variant.price;
          option.disabled = !variant.available;
          if (String(variant.id) === String(data.variantId) || (!data.variantId && index === 0)) {
            option.selected = true;
          }
          els.bundleVariantSelect.appendChild(option);
        });
      }

      updateCardPriceDisplay(els.bundleCard);
    }

    function showBundleFallbackSection() {
      if (!els.bundleFallbackSection) return;

      els.bundleFallbackSection.hidden = false;
      els.bundleFallbackSection.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(function () {
        els.bundleFallbackSection.classList.add('is-visible');
      });

      setTimeout(function () {
        els.bundleFallbackSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 120);
    }

    function isDockedBundlePopupEnabled() {
      return !!(els.soldOutModal && els.soldOutModal.dataset.dockedPopupEnabled === 'true');
    }

    function mountDockedModalIntoUpgrades() {
      if (!els.soldOutModal || !els.upgradesSection) return;

      if (!els.upgradesSection.contains(els.soldOutModal)) {
        els.upgradesSection.appendChild(els.soldOutModal);
      }
    }

    function applyModalMode() {
      if (!els.soldOutModal) return;

      const docked = isDockedBundlePopupEnabled();

      els.soldOutModal.classList.toggle('workspace-modal--docked', docked);

      const backdrop = els.soldOutModal.querySelector('.workspace-modal__backdrop');
      if (backdrop) {
        backdrop.hidden = docked;
      }

      if (docked) {
        mountDockedModalIntoUpgrades();
      }
    }

    function openSoldOutModal(card) {
      const fallbackData = getFallbackDataFromCard(card) || getSectionDefaultFallbackData();
      state.activeSoldOutCard = card;
      state.activeModalFallback = fallbackData;

      if (!els.soldOutModal) return;

      applyModalMode();

      const productName = card.dataset.productTitle || card.dataset.title || 'This product';

      if (els.soldOutModalProductLine) {
        els.soldOutModalProductLine.textContent = `${productName} is currently sold out separately.`;
      }

      if (fallbackData) {
        if (els.soldOutModalCopy) {
          els.soldOutModalCopy.textContent = fallbackData.subtitle || 'But you can still get it with the Go Pack.';
        }
        if (els.soldOutPrimary) {
          els.soldOutPrimary.hidden = false;
          els.soldOutPrimary.textContent = fallbackData.cta || 'Get it with Go Pack';
        }
      } else {
        if (els.soldOutModalCopy) {
          els.soldOutModalCopy.textContent = `${productName} is currently unavailable.`;
        }
        if (els.soldOutPrimary) {
          els.soldOutPrimary.hidden = true;
        }
      }

      els.soldOutModal.hidden = false;
      els.soldOutModal.setAttribute('aria-hidden', 'false');

      if (!isDockedBundlePopupEnabled()) {
        document.body.classList.add('workspace-modal-open');
      }
    }

    function closeSoldOutModal() {
      if (!els.soldOutModal) return;
      els.soldOutModal.hidden = true;
      els.soldOutModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('workspace-modal-open');
      state.activeSoldOutCard = null;
      state.activeModalFallback = null;
    }

    function openSoldOutFlow(card) {
      openSoldOutModal(card);
    }

    function chooseBundleFromSoldOutModal() {
      const fallbackData = state.activeModalFallback || getSectionDefaultFallbackData();
      closeSoldOutModal();

      if (!fallbackData || !els.bundleCard) return;

      updateBundleCardFromFallbackData(fallbackData);
      showBundleFallbackSection();
      selectCard(els.bundleCard, false);
    }

    section.addEventListener('change', function (event) {
      if (isSoldOutModalOpen()) {
        const isInsideModal = !!event.target.closest('#workspace-soldout-modal-' + sectionId);
        if (!isInsideModal) {
          event.preventDefault();
          event.stopPropagation();
          triggerModalShake();
          return;
        }
      }

      const variantSelect = event.target.closest('.workspace-card__variant-select, [data-bundle-variant-select]');
      if (!variantSelect || !section.contains(variantSelect)) return;

      const card = variantSelect.closest('.workspace-card--core, .workspace-card--upgrade, .workspace-accessory, .workspace-bundle-card');
      if (!card) return;

      updateCardPriceDisplay(card);
      syncSelectedItemVariant(card);
    });

    section.addEventListener('click', async function (event) {
      const modalElement = els.soldOutModal;
      const clickedInsideModal = !!(modalElement && event.target.closest('#workspace-soldout-modal-' + sectionId));
      const clickedDialog = !!(modalElement && event.target.closest('#workspace-soldout-modal-' + sectionId + ' .workspace-modal__dialog'));
      const clickedBackdrop = !!(modalElement && event.target.closest('#workspace-soldout-modal-' + sectionId + ' .workspace-modal__backdrop'));

      if (isSoldOutModalOpen()) {
        const closeButton = event.target.closest('.workspace-modal__close');
        const secondaryButton = event.target.closest('.workspace-modal__secondary');
        const soldOutPrimary = event.target.closest('[data-soldout-primary]');

        if (soldOutPrimary && section.contains(soldOutPrimary)) {
          event.preventDefault();
          chooseBundleFromSoldOutModal();
          return;
        }

        if (closeButton && section.contains(closeButton)) {
          event.preventDefault();
          closeSoldOutModal();
          return;
        }

        if (secondaryButton && section.contains(secondaryButton)) {
          event.preventDefault();
          closeSoldOutModal();
          return;
        }

        if (clickedBackdrop || !clickedInsideModal) {
          event.preventDefault();
          event.stopPropagation();
          triggerModalShake();
          return;
        }

        if (clickedInsideModal && !clickedDialog) {
          event.preventDefault();
          event.stopPropagation();
          triggerModalShake();
          return;
        }
      }

      const chip = event.target.closest('.workspace-chip');
      if (chip && section.contains(chip)) {
        const targetId = chip.dataset.target;
        if (targetId) {
          const target = section.querySelector('#' + targetId);
          if (target) {
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        return;
      }

      const discountBtn = event.target.closest('#workspace-discount-code-btn');
      if (discountBtn && section.contains(discountBtn)) {
        event.preventDefault();
        const code = els.discountCodeText ? els.discountCodeText.dataset.code || '' : '';
        const copied = await copyDiscountCode(code, discountBtn);
        setCopiedState(code, copied);
        return;
      }

      const mobileDiscountBtn = event.target.closest('#workspace-mobile-discount-code-btn');
      if (mobileDiscountBtn && section.contains(mobileDiscountBtn)) {
        event.preventDefault();
        const code = els.mobileDiscountCodeText ? els.mobileDiscountCodeText.dataset.code || '' : '';
        const copied = await copyDiscountCode(code, mobileDiscountBtn);
        setCopiedState(code, copied);
        return;
      }

      const removeBtn = event.target.closest('.workspace-summary__remove');
      if (removeBtn && section.contains(removeBtn)) {
        event.preventDefault();
        const row = removeBtn.closest('[data-remove-key]');
        const key = row ? row.getAttribute('data-remove-key') : '';
        if (key) handleRemoveItem(key);
        return;
      }

      const desktopCTA = event.target.closest('#workspace-add-bundle');
      if (desktopCTA && section.contains(desktopCTA)) {
        event.preventDefault();
        submitToCart(desktopCTA);
        return;
      }

      const mobileCTA = event.target.closest('#workspace-mobile-cta');
      if (mobileCTA && section.contains(mobileCTA)) {
        event.preventDefault();
        submitToCart(mobileCTA);
        return;
      }

      const cardButton = event.target.closest('.workspace-card__button, .workspace-accessory__button, .workspace-bundle-card__button');
      if (cardButton && section.contains(cardButton)) {
        event.preventDefault();
        const card = cardButton.closest('.workspace-card--core, .workspace-card--upgrade, .workspace-accessory, .workspace-bundle-card');
        if (card) toggleCard(card);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && els.soldOutModal && !els.soldOutModal.hidden) {
        closeSoldOutModal();
      }
    });

    allSelectableCards.forEach(function (card) {
      updateCardPriceDisplay(card);
    });

    let hasDefaultCore = false;

    cards.forEach(function (card) {
      const type = card.dataset.type;

      if (type === 'core' && card.dataset.selectedByDefault === 'true' && !hasDefaultCore) {
        selectCard(card, true);
        hasDefaultCore = true;
      } else {
        updateCardUI(card, false);
      }
    });

    if (els.bundleCard) {
      updateCardUI(els.bundleCard, false);
    }

    attachDesktopCTAGlow(els.desktopCTA);

    applyModalMode();
    render();
    applyCTAContrastColors();
    resetMobileCanvasScaling();
    syncFromCart();

    window.addEventListener('focus', function () {
      syncFromCart();
    });

    window.addEventListener('resize', function () {
      applyCTAContrastColors();
      resetMobileCanvasScaling();
      applyModalMode();
    });

    setInterval(function () {
      syncFromCart();
    }, 15000);
  });
}